'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var keyPrefix = exports.keyPrefix = 'reduxPersist:';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';
var REHYDRATE_ERROR = exports.REHYDRATE_ERROR = 'persist/REHYDRATE_ERROR';


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/lib/constants.js
 ** module id = 37
 ** module chunks = 0
 **/